<template>
  <div class="barometer-indicator">
    <div class="barometer-indicator-inner" :style="{borderTop: `4px solid ${color}`}">
      <div class="barometer-indicator--title t-chartbody" :style="{color}" v-html="title"></div>
      <div class="barometer-indicator--stat"><h4 class="m-b-14" :style="{color}">{{stat}}</h4></div>
      <div class="barometer-indicator--body"><p class="m-0 t-darker-grey" v-html="body"></p></div> <!-- Using HTML is dangerous here, but the caller uses superscripts :( -->
    </div>
  </div>
</template>
<script>
export default {
  name: 'BarometerIndicator',
  props: {
    title: {
      type: String,
      required: true
    },
    stat: {
      type: String,
      required: true
    },
    body: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    }
  }
}
</script>
<style lang="scss">
@import '../scss/mixins';

// Leaving unscoped because the parent may need to position us or tweak things
.barometer-indicator {
  display: flex;
  .barometer-indicator-inner {
    margin: 4px 0;
    @media(min-width: $screen-md-min) {
      // margin: 4px;
    }
    box-shadow: 0px 18px 28px 0px rgba(0,0,0,0.04);
    display: flex;
    flex-direction: column;
    background: $white;
    padding: 30px;
    width: calc(100% - 8px);
  }
  .barometer-indicator--title {
    // margin-bottom: 70px;
    min-height: 100px;
  }
  .barometer-indicator--stat {

  }
  .barometer-indicator--body {
    p {
      font-size: px2rem(15);
      line-height: px2rem(23);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BarometerIndicator.vue